module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.6.2/_next/static/images/friend-justice-b3c70bc49af1103722f4c69259356ae1.webp";